import { clsx } from 'clsx'
import { useCallback } from 'react'

import { usePageInfo } from '@lib/hooks/use-page-info'
import { gnarSpec } from '@lib/tracking/gnar'

import { Button } from '@components/ui-core/button/button'

import { useStep } from '../hooks/use-step'
import { Step } from '../utils/steps'

import style from './try-it-now-button.module.scss'

/**
 * Try it now button for Superhuman Go Intro page
 */
export const TryItNowButton = () => {
  const { step } = useStep()
  const { pageId, slug } = usePageInfo()

  const ctaButtonText = 'Try it now'
  const ctaButtonCategory = 'primary'

  const handleClick = useCallback(() => {
    // Track the button click
    void gnarSpec.ctaButtonClick({
      ctaType: 'superhumanGoIntroTryItNow',
      displayContent: ctaButtonText,
      metadata: {
        placement: 'Header',
        styleVariant: ctaButtonCategory,
      },
      pageId,
      pageSlug: slug,
    })

    // Scroll to the "Go time" step
    const element = document.querySelector(`[data-step="${Step.GoTime}"]`)
    element?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [pageId, slug])

  return (
    <Button
      category={ctaButtonCategory}
      text={ctaButtonText}
      isCompact
      variant="heart"
      className={clsx(
        style.tryItNowButton,
        // The whole point of this button is to scroll the user to the "Go time" step.
        // So, if the step is "Go time", we hide the button.
        step === Step.GoTime && style.tryItNowButtonHidden,
      )}
      onClick={handleClick}
    />
  )
}
